const DISCLAIMER_GIF = `https://media.giphy.com/media/Z1kpfgtHmpWHS/giphy.gif`;

const DISCLAIMER_TITLE = `Sup 👋 Important Disclaimer`;

const DISCLAIMER_TEXT_FIRST = `This app was built for learning purposes only, please note no copyright infringement is intended.`;

const DISCLAIMER_TEXT_SEC = `Echoboard does not own nor claim to own any of the songs listed here. Use this app at your own risk.`;

const DISCLAIMER_BTN_TEXT = `Okay, undestood`;

export {
  DISCLAIMER_GIF,
  DISCLAIMER_TITLE,
  DISCLAIMER_BTN_TEXT,
  DISCLAIMER_TEXT_FIRST,
  DISCLAIMER_TEXT_SEC,
};
